import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import Ratings from '../Ratings'

function CarRating({ digitalCertificate }) {
  const { basicData, rating } = digitalCertificate
  const { t } = useTranslation()

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={6}>
        <Typography variant="h3">
          <strong>{`${basicData.make} ${basicData.model}`}</strong>
        </Typography>
        <Typography variant="body2">{basicData.version}</Typography>

        <Box sx={{ mt: 2, mb: 1 }}>
          <Typography>
            <strong>{t('pdf.rating.categories')}</strong>
          </Typography>
          <Ratings label={t('pdf.rating.body')} score={rating?.body || 0} />
          <Ratings
            label={t('pdf.rating.interior')}
            score={rating?.interior || 0}
          />
          <Ratings
            label={t('pdf.rating.equipment')}
            score={rating?.equipment || 0}
          />
          <Ratings label={t('pdf.rating.tyres')} score={rating?.tyres || 0} />
          <Ratings
            label={t('pdf.rating.technical')}
            score={rating?.technical || 0}
          />
        </Box>
        <Ratings
          big
          label={t('pdf.rating.overall')}
          score={basicData.controlRating || 0}
        />
      </Grid>
      <Grid item xs={6}>
        <Box sx={{}}>
          <img
            src={basicData.imageUrl}
            alt=""
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

CarRating.propTypes = {
  digitalCertificate: PropTypes.object,
}
CarRating.defaultProps = {
  digitalCertificate: {},
}

export default CarRating
